import React, {  useState } from 'react'
import maximize from '../ui/miximize.svg'
import './nameBox.css'
import ForcedLabourDetails from './ForcedLabourDetails';

function NameBox({ allNames }) {



    // const [loading, setLoading] = useState(true); // Loading state
    // const [error, setError] = useState(null); // Error state

    // const [names, setNames] = useState([]);
    const [selectedName, setSelectedName] = useState(null);

    const [isVisible, setIsVisible] = useState(false);



    const handleNameClick = (i) => {
        setSelectedName(allNames[i])
    }


    const handleDataFromChild = (visibility) => {
        setSelectedName(visibility);
    }

    return (
        <div>


            <div className='container'>
                {allNames.map((item, i) => {

                    return (



                        <div className='individualContainer' key={item._id} onClick={() => handleNameClick(i)}>

                            <div className='nameContainer' key={item._id + '_nameContainer'}>
                                <div className='Name' key={item._id + '_Vorname'}>{item.Vorname}</div>
                                <div className='surName' key={item._id + '_Nachname'}>{item.Nachname}</div>

                            </div>

                            <div className='maximize' key={item._id + '_maximize'}>
                                <img src={maximize} alt="" />

                            </div>
                        </div>


                    )


                })}

            </div>

            {selectedName && <ForcedLabourDetails person={selectedName} visible={isVisible} onSendData={handleDataFromChild}></ForcedLabourDetails>}


        </div>
    )
}

export default NameBox